export var checkSpecificError = function checkSpecificError(error) {
  return ['com.ots.common.common_http.core.exception.ServiceException'].includes(error);
};